import { PersistenceError } from "@note-app/storage";

export type IndexedDbFailureCode =
  | "corrupt-data"
  | "quota-exceeded"
  | "blocked"
  | "unavailable";

export class IndexedDbStorageError extends PersistenceError {
  public constructor(
    public readonly browserCode: IndexedDbFailureCode,
    message: string,
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = "IndexedDbStorageError";
  }
}

export function mapIndexedDbError(
  error: unknown,
  fallback: string,
): IndexedDbStorageError {
  if (error instanceof IndexedDbStorageError) return error;
  const name =
    typeof error === "object" &&
    error !== null &&
    "name" in error &&
    typeof error.name === "string"
      ? error.name
      : "";
  if (name === "QuotaExceededError") {
    return new IndexedDbStorageError(
      "quota-exceeded",
      "Browser storage quota was exceeded. Export a backup before freeing space.",
      { cause: error },
    );
  }
  return new IndexedDbStorageError("unavailable", fallback, { cause: error });
}
